export const initialUser = {
  first_name: "",
  last_name: "",
  username: "",
  email: "",
  password: "",
  password_confirmation: "",
  user_type: "user",
  active: true,
  groups: [],
};
